export default __webpack_public_path__ + "static/media/wave.d7e2b42c.svg";